import { CheckableFieldContext } from "./chunk-EYE6MH2Q.js";

// src/components/CheckableField/CheckableField.Wrap.tsx
import { useContext } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var CheckableFieldWrap = _ref => {
  let {
    className,
    children
  } = _ref;
  const {
    id
  } = useContext(CheckableFieldContext);
  return /* @__PURE__ */jsx("label", {
    htmlFor: id,
    className: clsx("pd:checkable-field__wrap", className),
    children
  });
};
var CheckableField_Wrap_default = CheckableFieldWrap;
export { CheckableField_Wrap_default };